import QRCode from 'qrcode';
import { downloadUrl } from '../../Forms/shared/exporters/browser';

// A real QR code for the W-9 link (w9-plan T19): `qrcode` draws it onto a
// canvas for the screen and renders a PNG for the download. The module's
// default colours (black on white) stay, whatever the admin's theme, so
// phones can scan it off a printed sheet or a bright screen.

export const QR_SIZE = 200;
export const QR_PNG_SIZE = 640;

// Draws `text` into `canvas` at `size` px. Resolves when drawn.
export const drawQr = (canvas, text, size = QR_SIZE) =>
  QRCode.toCanvas(canvas, text, { width: size, margin: 2 });

export const qrPngDataUrl = (text) =>
  QRCode.toDataURL(text, { width: QR_PNG_SIZE, margin: 3 });

// "w9-qr-<slug>.png"
export const qrFilename = (slug) => `w9-qr-${slug || 'link'}.png`;

// Renders the PNG and saves it. Resolves when the download was started.
export const downloadQr = (text, filename) =>
  qrPngDataUrl(text).then((url) => downloadUrl(url, filename));
